import React from 'react'
import MediaQuery from 'react-responsive'
import Mixpanel from '../common/mixpanel'

import Loader from '../common/components/loading'
import Sidebar from './sidebar'
import Property, { PropertyInfo } from '../common/components/property'
import Map from '../common/components/property_map/index'
import FeaturedProperties from './featured'
import { PropertyData, Filters } from '../common/models/properties'
import { Currency } from '../common/utils/currency'

interface GlobalConfig {
  currency?: Currency
}

function globalConfig() {
  if (window['RS']) {
    const config = window['RS'] as GlobalConfig

    return Object.assign({}, {
      currency: Currency.EUR
    }, config)
  }
}

interface DestinationsProps {
  initialRegion?: string | null
  initialExperience?: string | null

  guest?: boolean
  promptUpdatePrefs?: boolean
}

interface DestinationsState {
  properties: PropertyData[]
  featured: PropertyData[]
  filters: Filters
  sort: string
  loading: boolean
  page: number
  pageSize: number
  totalPages: number
  gridView: boolean
  selectedMapPropertyId: number
}

export default class Destinations extends React.Component<DestinationsProps, DestinationsState> {
  static get defaultProps() {
    return {
      initialRegion: null,
      initialExperience: null,
      promptUpdatePrefs: false
    }
  }

  constructor(props: DestinationsProps) {
    super(props)

    this.updateFilters = this.updateFilters.bind(this)
    this.updateSorting = this.updateSorting.bind(this)
    this.reloadProperties = this.reloadProperties.bind(this)
    this.goToPage = this.goToPage.bind(this)
    this.toggleGridView = this.toggleGridView.bind(this)
    this.renderPageSizes = this.renderPageSizes.bind(this)
    this.renderPagination = this.renderPagination.bind(this)

    let filters = {}
    // Load initial region
    if (props.initialRegion) {
      filters = { region_id: [props.initialRegion] }
    }

    // Load initial experience
    if (props.initialExperience) {
      filters = { interest_ids: [props.initialExperience] }
    }

    if (history.state && history.state.filters) {
      if (Object.keys(history.state.filters).length > 0) {
        filters = history.state.filters
      }
    }

    this.state = {
      properties: [],
      featured: [],
      filters: filters,
      sort: "recommended-desc",
      loading: true,
      page: 1,
      pageSize: 12,
      totalPages: 1,
      gridView: true,
      selectedMapPropertyId: 0
    }
  }

  guest(): boolean {
    return this.props.guest
  }

  componentWillMount() {
    this.reloadProperties(() => {
      this.reloadFeaturedProperties()
    })
  }

  encodeFilters(filters) {
    let params = []

    for (let d in filters) {
      const val = filters[d]
      if (val) {
        if (typeof val === 'string') {
          // Only add strings with a value
          if (val.length > 0) {
            params.push(encodeURIComponent(d) + '=' + encodeURIComponent(filters[d]))
          }
        } else {
          if (Array.isArray(val) && val.length > 0) {
            for (let sub in val) {
              params.push(encodeURIComponent(d) + '[]=' + encodeURIComponent(val[sub]))
            }
          } else {
            for (let sub in val) {
              params.push(encodeURIComponent(d) + `[${encodeURIComponent(sub)}]=` + encodeURIComponent(val[sub]))
            }
          }
        }
      }
    }

    if (this.state.gridView) {
      params.push(`page=${this.state.page}`)
      params.push(`per_page=${this.state.pageSize}`)
    } else {
      params.push(`page=1`)
      params.push(`per_page=600`)
    }

    let sorting = this.state.sort.split('-')
    if (sorting.length == 2) {
      params.push(`sort=${sorting[0]}`)
      params.push(`direction=${sorting[1]}`)
    }

    if (globalConfig().currency) {
      params.push(`currency=${globalConfig().currency}`)
    }

    return params.join('&')
  }

  updateFilters(filters: Filters) {
    const self = this

    this.setState({
      properties: [],
      loading: true,
      filters: filters,
      page: 1
    }, () => {
      self.reloadProperties(() => {
        self.reloadFeaturedProperties()
      })
    })
  }

  updateSorting(event) {
    const self = this

    this.setState({
      sort: event.target.value
    }, () => {
      self.reloadProperties()
    })
  }

  reloadProperties(callback = () => {}) {
    const self = this

    if (Object.keys(this.state.filters).length > 0) {
      history.pushState({ filters: this.state.filters }, "Destinations | Rocksure", window.location.pathname)
    }

    fetch(`/api/v1/properties?${self.encodeFilters(this.state.filters)}`, {
      method: "GET",
      credentials: 'same-origin'
    })
    .then(resp => {
      return resp.json()
    })
    .then(json => {
      self.setState({
        properties: json.properties || [],
        page: json.current_page,
        totalPages: json.total_pages,
        loading: false
      }, () => {
        if (Mixpanel.enabled) {
          const mp_properties = Object.assign({}, this.state.filters, {
            sort: this.state.sort,
            grid: this.state.gridView
          })

          Mixpanel.track('Browse Properties', mp_properties)
        }

        callback()
      })
    })
  }

  reloadFeaturedProperties() {
    const self = this
    const params = self.encodeFilters(this.state.filters) + `&featured=true`

    fetch(`/api/v1/properties?${params}`, {
      method: "GET",
      credentials: 'same-origin'
    })
    .then(resp => {
      return resp.json()
    })
    .then(json => {
      self.setState({
        featured: json.properties || []
      })
    })
  }

  goToPage(page) {
    const self = this

    // Manually scroll to top of list
    $('html, body').animate({
      scrollTop: $(".destinations-page-size").offset().top - 120
    }, 1000);
    
    this.setState({
      loading: true,
      page: page
    }, () => {
      self.reloadProperties()
    })
  }

  toggleGridView() {
    const self = this

    this.setState({
      gridView: !this.state.gridView
    }, () => {
      self.reloadProperties()
    })
  }

  renderFeaturedProperties() {
    const featured = this.state.featured.slice(0, 6)

    if (featured.length > 0) {
      return (
        <div className="featured-properties">
          <div className="row">
            <div className="small-12 columns">
              <h2>Featured Properties</h2>
            </div>

            <div className="small-12 columns">
              <FeaturedProperties properties={featured} guest={this.guest()} />
            </div>
          </div>
        </div>
      )
    } else {
      return undefined
    }
  }

  renderPageSizes() {
    const { pageSize, gridView } = this.state

    return (
      <div className="destinations-page-size">
        <div className="row">
          <div className="small-12 medium-7 columns">
            <div className="button-group destinations-view-toggles">
              <button onClick={this.toggleGridView} className={"button primary " + (!gridView ? 'hollow' : '') }>List View</button>
              <button onClick={this.toggleGridView} className={"button primary " + (gridView ? 'hollow' : '') }>Map View</button>
            </div>
          </div>

          { gridView && <div className="small-12 medium-3 columns destinations-sorting select-plain">
            <select id="js-destinations-sort" value={this.state.sort} onChange={this.updateSorting}>
              <option value="recommended-desc">Recommended</option>
              <option value="name-asc">Name Ascending</option>
              <option value="name-desc">Name Descending</option>
              <option value="from_price-asc">Price Ascending</option>
              <option value="from_price-desc">Price Descending</option>
              <option value="published_at-desc">Most Recently Added</option>
            </select>
            <label htmlFor="js-destinations-sort"> </label>
          </div> }

          { gridView && <div className="small-12 medium-2 columns page-size-filters">
            { [12, 24, 36].map(size => {
              return <span key={`size-${size}`} className={ size == pageSize ? 'active' : ''} onClick={() => {
                const self = this
                this.setState({
                  pageSize: size
                }, () => {
                  self.reloadProperties()
                })
              }}>{ size }</span>
            }) }
          </div> }
        </div>
      </div>
    )
  }

  renderPagination() {
    const { page, totalPages } = this.state
    
    // Clamp to prev 5 and next 5 pages of the total
    var pages = []
    for (var i = Math.max(1, page - 5); i <= Math.min(totalPages, page + 10); i++) {
      pages.push(i)
    }

    return (
      <div className="destinations-pagination">
        { page > 1 ? <a href="javascript:void(0)" onClick={() => { this.goToPage(page - 1) }}>&lt; Back</a> : undefined }

        { pages.map((p) => {
          if (p == page) {
            return <a key={p} href="javascript:void(0)"><strong style={{'textDecoration': 'underline'}}>{ p }</strong></a>
          } else {
            return <a key={p} href="javascript:void(0)" onClick={() => {
              this.goToPage(p)
            }}>{ p }</a>
          }
        }) }

        { page < totalPages ? <a href="javascript:void(0)" onClick={() => { this.goToPage(page + 1) }}>Next &gt;</a> : undefined }
      </div>
    )
  }

  renderPropertiesGrid(properties) {
    return (
      <div className="properties-grid">
        { !this.state.loading ? properties : undefined }

        { !this.state.loading && properties.length == 0 ? <p className="text-center" style={{'marginTop': '4em'}}>No properties matching your criteria could be found. Please try broadening your search.</p> : undefined }
      </div>
    )
  }

  renderPropertiesMap(properties) {
    const selected = properties.find(p => { return p.id == this.state.selectedMapPropertyId })

    return (
      <div>
        <div className="properties-map mg-l-b">
          <Map properties={properties} guest={this.guest()} onPropertySelected={(property) => {
            this.setState({
              selectedMapPropertyId: property.id
            })
          }} />
        </div>

        { selected ? <MediaQuery maxWidth={800}>
          <Property property={selected} infoFirst={true} guest={this.guest()} />
        </MediaQuery> : undefined }
      </div>
    )
  }

  render() {
    const { gridView } = this.state

    const propertiesGrid = this.state.properties.map(p => {
      return (
        <div key={p.slug} className="property-grid-item">
          <Property property={p} guest={this.guest()} />
        </div>
      )
    })

    return (
      <div className="row">
        <div className="large-3 medium-4 small-12 columns">
          <Sidebar currency={globalConfig().currency} initialFilters={this.state.filters} filtersUpdated={this.updateFilters} />
        </div>

        <div className="large-9 medium-8 small-12 columns">
          { this.renderFeaturedProperties() }

          { this.props.promptUpdatePrefs ? <div className="callout primary mg-t text-center">
            Improve your recommended search results by <strong><a href="/account/preferences">updating your preferences</a></strong>.
          </div> : undefined }

          { this.renderPageSizes() }

          { this.state.loading ? <Loader /> : undefined }

          { gridView ? this.renderPropertiesGrid(propertiesGrid) : undefined }
          { !gridView ? this.renderPropertiesMap(this.state.properties) : undefined }

          { !this.state.loading && gridView ? this.renderPagination() : undefined }
        </div>
      </div>
    )
  }
}